import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { QuickbooksService }  from './quickbooks.service';

angular.module('app-lite.quickbooks', [])
  .service('quickbooksApi', downgradeInjectable(QuickbooksService));
